interface UserSettingsApi {
    isEnabledPushNotifications: () => boolean;
    setIsEnabledPushNotifications: (isEnabled: boolean) => void;
}

const userSettingsApi: UserSettingsApi = {
    isEnabledPushNotifications: () => {
        const isEnabledPushNotifications = localStorage.getItem("isEnabledPushNotifications");
        return isEnabledPushNotifications === "true";
    },
    setIsEnabledPushNotifications: (isEnabled: boolean) => {
        localStorage.setItem("isEnabledPushNotifications", isEnabled.toString());
    }
}

export default userSettingsApi;